module.exports = __webpack_public_path__ + "img/reference_04.5a1e29bd.jpg";